import { render, staticRenderFns } from "./WorkflowSaveStatus.vue?vue&type=template&id=404dd4ef&scoped=true&"
import script from "./WorkflowSaveStatus.vue?vue&type=script&lang=js&"
export * from "./WorkflowSaveStatus.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowSaveStatus.vue?vue&type=style&index=0&id=404dd4ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404dd4ef",
  null
  
)

export default component.exports